export default __webpack_public_path__ + "static/media/Inter-Black.7bb62343.woff";